import { HttpService } from 'core/modules/network-service';
import { get } from 'lodash';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { getVisibleItems } from 'resolvers/getVisibleEntities';

/*************************************************************/

/**
 * @type {class}
 * @desc OrderToDo defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { OrderToDoService } from 'services/orderToDo';
 *
 * // create service instance and send/cancel request
 * const orderToDoService = new OrderToDoService();
 * const result = await orderToDoService.fetchData( '<user-id>' ); // fetch data
 * orderToDoService.cancel(); // cancel an active request
 */
export class OrderToDoService extends HttpService {

    // make request and fetch data
    async fetchFormComponents( { url, data } ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data,
            } );


            // extract widgets from the response
            const visibility = get( response, 'body.component.visibility', {} );
            const fields = get( response, 'body.component.structure.fields', [] );
            const navActions = get( response, 'body.component.structure.actions', [] );
    
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: {
                    formFields: getVisibleItems( fields, visibility ),
                    navActions: getVisibleItems( navActions, visibility ),
                    formData: get( response, 'body.component.data' ),
                }
            };
            
        } catch( errResponse ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }

    // submit form data
    async submitFormData( { url, data } ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data: data
            } );
    
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE )
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE
            };
        }
    }
}
